// extracted by mini-css-extract-plugin
export default {"info":"cr7VLisz8v","h-rule":"_6k5YWITi4L","hRule":"_6k5YWITi4L","logo":"ds4sJvokTA","further-resources":"SaSTwHfdFI","furtherResources":"SaSTwHfdFI"};
    if(module.hot) {
      // 1653462682133
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  